import { z } from 'zod/v4';
export const searchEnvelopeSchema = (itemSchema, facetsSchema) => z.object({
    items: z.array(itemSchema),
    total: z.number().int(),
    totalUnfiltered: z.number().int(),
    facets: facetsSchema,
    hasMore: z.boolean(),
});
export const searchInputSchema = (filtersSchema) => z.object({
    query: z
        .string()
        .optional()
        .describe('Free-text relevance query matched against entity summary fields. It is case- and accent-insensitive, typo-tolerant, and searches each word independently, so word order does not matter and any matching word can surface a result. Results are ranked by relevance. Use one concise query; do not retry spelling or word-order variations. Structured filters remain exact.'),
    // prefault, not default: an omitted filters is parsed through the schema, so per-tool inner defaults still apply
    filters: filtersSchema
        .prefault({})
        .describe('Entity-specific structured filters. Omit or pass `{}` to see all items plus facets (the standard discovery move). Some search tools have required fields inside filters; in those cases fill them in.'),
    limit: z
        .number()
        .int()
        .min(1)
        .max(50)
        .optional()
        .describe('Max items to return (1–50, default 20). Hard cap, not a page size — there is no pagination. When `hasMore` is true, narrow `query`/`filters` to surface more; re-calling does not advance.'),
});
//# sourceMappingURL=envelope.js.map